import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-2xl font-bold mb-4">Oops! Something went wrong</h1>
          <p>GenAI is changing fast. We encountered a hiccup -- Growing pains. Please try again or report the problem to us.</p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

